import { CheckmarkIcon, CloseIcon } from 'app/common/presentation/icons'

import { IconButton } from 'components'

import { UINotification } from './Notifications'
import styles from './Notifications.module.scss'

interface NotificationProps {
  notification: UINotification
  onClose: () => void
}

const Notification = ({ notification, onClose }: NotificationProps) => (
  <div
    className={[
      styles.notification,
      styles[notification.type],
      notification.shown === undefined ? undefined : notification.shown ? styles.show : styles.hide,
    ].join(' ')}
  >
    <CheckmarkIcon />
    <div className={styles.info}>
      {notification.title && <div className={styles.title}>{notification.title}</div>}
      <div className={styles.message}>{notification.message}</div>
    </div>
    <IconButton icon={CloseIcon} onClick={onClose} small variant="tertiary" />
  </div>
)

export default Notification
